import React from 'react';
import './App.css';
import { CssBaseline } from '@mui/material';
import { Route, Routes } from 'react-router-dom';
import Home from './components/Home/Home';
import BuzzHome from './components/Buzz/BuzzHome';
import TermsOfService from './components/TndL/Terms-of-service';
import PrivacyPolicy from './components/TndL/PrivacyPolicy';
import DeepLinks from './components/DeepLinks/DeepLinks';
import BuzzCrew from './components/Buzz/BuzzCrew';
import { HelmetProvider } from 'react-helmet-async';
import PreRegistration from './components/Buzz/PreRegisteration';
import ChildSafetyPolicy from './components/TndL/ChildSafetyPolicy';
import CommunityRedirect from './components/Community/CommunityRedirect';
import RedirectPage from './components/Redirection/RedirectPage';
import EventValidationScreen from './components/Events/EventValidationScreen';

function App() {
    return (
        <>
            <HelmetProvider>
                <CssBaseline />
                <Routes>
                    <Route path='/' element={<BuzzHome />} />
                    <Route path="/c/*" element={<CommunityRedirect />} />
                    <Route path="/r/:shortCode" element={<RedirectPage />} />
                    <Route path="/evt/verify" element={<EventValidationScreen />} />
                    <Route path='/terms-of-service' element={<TermsOfService />} />
                    <Route path='/privacy-policy' element={<PrivacyPolicy />} />
                    <Route path='/cerkle-crew' element={<BuzzCrew />} />
                    <Route path='/feed/post' element={<DeepLinks />} />
                    <Route path='/profile/user' element={<DeepLinks />} />
                    <Route path='/pre-registration' element={<PreRegistration /> } />
                    <Route path='/child-safety-standards' element={<ChildSafetyPolicy />} />
                </Routes>

            </HelmetProvider>

        </>

    );
}

export default App;